import { createSelector } from '@reduxjs/toolkit';

import type { FavouritesState } from '.';

type State = { favourites: FavouritesState };

const selectFavourites = (state: State) => state.favourites;

export const selectFavouritesIds = createSelector(
  selectFavourites,
  (state) => state.favouritesIds
);

export const selectIsFavouritesLoaded = createSelector(
  selectFavourites,
  (state) => state.isFavouritesLoaded
);
